<template>
  <div class="lines" :class="{'show' : show || $route.name === 'Lab'}">
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex';

export default {
  name: 'Lines',
  computed: {
    ...mapGetters({
      show: 'show'
    })
  },
}
</script>

<style lang="scss">
.lines{
  pointer-events: none;
  position: fixed;
  z-index: 150;
  top: 0;
  left: var(--body-padding);
  right: var(--body-padding);
  width: auto;
  height: 100%;
  &.show {
    .line {
      // transition: opacity 0s var(--easing);
      transition: opacity 0s .2s var(--easing);
    }
  }
  .line{
    position: absolute;
    top: 0;
    width: 1px;
    height: 100%;
    background: rgba(148, 148, 148, 0.295);
    left: 0;
    transition: opacity 0s .2s var(--easing);
    &:nth-child(1) {
      left: calc(100% + 6px);
    }
    &:nth-child(2) {
      left: calc((((100vw) / 4) * 1) - 5.5vw);
    }
    &:nth-child(3) {
      left: calc((((100vw) / 4) * 2) - 5.5vw);
    }
    &:nth-child(4) {
      left: calc((((100vw) / 4) * 3) - 5.5vw);
    }
    &:nth-child(5) {
      left: -6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Lines.vue